import { Link } from "react-router-dom";
import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Mail, Instagram, Copy, Check, Sparkles, ArrowRight } from "lucide-react";
import { AuthShell } from "@/pages/Login";

const CONTACT_EMAIL = "tech@ipnovaai.com";
const CONTACT_INSTA = "ipnova.ai";

export default function Signup() {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    try { await navigator.clipboard.writeText(CONTACT_EMAIL); setCopied(true); setTimeout(() => setCopied(false), 1600); toast.success("Email copied"); }
    catch { toast.error("Copy failed"); }
  };

  const subject = encodeURIComponent("Early access to ipnova.ai");
  const body = encodeURIComponent("Hi ipnova team,\n\nI'd love to get early access to ipnova.ai. Here's a bit about my business:\n\n- Business name:\n- What I want to automate:\n- My phone/WhatsApp:\n\nLooking forward to hearing from you.\n\nThanks!");

  return (
    <AuthShell title="Get early access" sub="Signups are invite-only while we onboard our first wave. Reach out and we'll set you up — usually within hours." testid="signup-page">
      <div className="space-y-3" data-testid="signup-contact-card">
        <div className="inline-flex items-center gap-2 text-xs tracking-[0.2em] uppercase text-emerald-300 bg-emerald-500/10 border border-emerald-500/30 rounded-full px-2.5 py-1">
          <Sparkles className="w-3 h-3"/> Limited beta · invite only
        </div>

        <a href={`mailto:${CONTACT_EMAIL}?subject=${subject}&body=${body}`} className="block group" data-testid="signup-email-cta">
          <div className="flex items-center justify-between bg-zinc-950 border border-white/10 rounded-xl p-4 hover:border-emerald-500/30 transition">
            <div className="flex items-center gap-3 min-w-0">
              <div className="w-10 h-10 rounded-md bg-emerald-500/10 border border-emerald-500/30 grid place-items-center shrink-0">
                <Mail className="w-4 h-4 text-emerald-400" />
              </div>
              <div className="min-w-0">
                <div className="text-xs tracking-[0.2em] uppercase text-zinc-500">Email us</div>
                <div className="text-sm font-medium truncate">{CONTACT_EMAIL}</div>
              </div>
            </div>
            <button type="button" onClick={(e) => { e.preventDefault(); copy(); }}
              className="text-zinc-400 hover:text-white shrink-0" data-testid="signup-email-copy">
              {copied ? <Check className="w-4 h-4 text-emerald-400"/> : <Copy className="w-4 h-4"/>}
            </button>
          </div>
        </a>

        <a href={`https://instagram.com/${CONTACT_INSTA}`} target="_blank" rel="noreferrer" className="block group" data-testid="signup-instagram-cta">
          <div className="flex items-center gap-3 bg-zinc-950 border border-white/10 rounded-xl p-4 hover:border-emerald-500/30 transition">
            <div className="w-10 h-10 rounded-md bg-emerald-500/10 border border-emerald-500/30 grid place-items-center shrink-0">
              <Instagram className="w-4 h-4 text-emerald-400" />
            </div>
            <div>
              <div className="text-xs tracking-[0.2em] uppercase text-zinc-500">DM on Instagram</div>
              <div className="text-sm font-medium">@{CONTACT_INSTA}</div>
            </div>
          </div>
        </a>

        <a href={`mailto:${CONTACT_EMAIL}?subject=${subject}&body=${body}`} data-testid="signup-primary-cta">
          <Button className="w-full mt-3 h-11 bg-white text-black hover:bg-zinc-200 font-medium">
            Contact the startup <ArrowRight className="ml-2 w-4 h-4"/>
          </Button>
        </a>

        <div className="text-xs text-zinc-500 text-center pt-2">We usually respond within a few hours.</div>

        <div className="text-sm text-zinc-500 text-center pt-4 border-t border-white/5 mt-4">
          Already have an account? <Link to="/login" className="text-white hover:underline" data-testid="signup-to-login">Sign in</Link>
        </div>
      </div>
    </AuthShell>
  );
}
